var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCartError = function SvgCartError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 78,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.372 8.625v4.978h9.956c1.07 0 1.983.7 2.333 1.71l4.647 41.476c.428 3.753 3.656 6.63 7.428 6.63h30.392v-4.977H28.736c-1.283 0-2.333-.934-2.47-2.198l-.31-2.78h31.577c3.54 0 6.63-2.528 7.33-5.989l4.765-23.878H22.59l-1.069-9.489-.078-.233c-.953-3.111-3.85-5.23-7.116-5.25H4.372ZM54.15 63.419a4.987 4.987 0 0 0-4.978 4.978 4.987 4.987 0 0 0 4.978 4.978 4.987 4.987 0 0 0 4.978-4.978 4.987 4.987 0 0 0-4.978-4.978Zm-24.889 0a4.987 4.987 0 0 0-4.978 4.978 4.987 4.987 0 0 0 4.978 4.978 4.987 4.987 0 0 0 4.978-4.978 4.987 4.987 0 0 0-4.978-4.978Zm-6.106-34.844h40.406l-3.578 17.908c-.253 1.186-1.244 2.003-2.45 2.003H25.391l-2.236-19.911Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67 2.833c-7.834 0-14.167 6.333-14.167 14.167S59.166 31.167 67 31.167 81.166 24.834 81.166 17 74.834 2.834 67 2.834Zm6.091 20.259a1.41 1.41 0 0 1-1.997 0L67 18.998l-4.094 4.094a1.41 1.41 0 0 1-1.998 0 1.41 1.41 0 0 1 0-1.998L65.002 17l-4.094-4.094a1.41 1.41 0 0 1 0-1.998 1.41 1.41 0 0 1 1.998 0L67 15.003l4.094-4.095a1.41 1.41 0 0 1 1.997 0 1.41 1.41 0 0 1 0 1.998L68.997 17l4.094 4.094c.539.539.539 1.445 0 1.998Z",
    fill: "#D65F5C"
  })));
};

export default SvgCartError;